import { __decorate } from "tslib";
import { uiMapper } from "@/services/store/modules/ui/store";
import { Vue, Component, Mixins } from "vue-property-decorator";
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(["breakpoint"]),
    },
});
let BlockSteam = class BlockSteam extends Mixins(UiMappers) {
    constructor() {
        super(...arguments);
        this.steam = [
            { letter: "S", decoding: "Наука" },
            { letter: "T", decoding: "Технологии" },
            { letter: "E", decoding: "Инженерия" },
            { letter: "A", decoding: "Искусство" },
            { letter: "M", decoding: "Математика" },
        ];
    }
    get isXs() {
        return this.breakpoint === "xs";
    }
};
BlockSteam = __decorate([
    Component({})
], BlockSteam);
export default BlockSteam;
